import * as _ from 'lodash';
import * as appConstants from '../constants/AppConstants';

export const ETF_FEE_PERCENTAGE = 0.3;

export const getRequestBodyFromApproval = (approvalObj) => {
  if (_.has(approvalObj, 'callBackDetails.requestBody.requestBody')) {
    return approvalObj.callBackDetails.requestBody.requestBody;
  }
  if (_.has(approvalObj, 'callBackDetails.requestBody.apiDetails.commerce-order-v4-place-order.requestBody')) {
    return approvalObj.callBackDetails.requestBody.apiDetails['commerce-order-v4-place-order'].requestBody;
  }
  return {};
};

export const calculateEtfFeeAmount = (totalValue) => {
  const numericTotal =
    typeof totalValue === 'string'
      ? parseFloat(totalValue.replace(/,/g, ''))
      : Number(totalValue);

  if (!numericTotal || isNaN(numericTotal)) {
    return 0;
  }

  return parseFloat((numericTotal * ETF_FEE_PERCENTAGE).toFixed(2));
};

const parseAmountFromDisplayValue = (displayValue) => {
  if (!displayValue) {
    return null;
  }

  const amount = displayValue.toString().split('|')[0];
  const numericAmount = parseFloat(amount.replace(/,/g, ''));
  return isNaN(numericAmount) ? null : numericAmount;
};

const parseCurrencyFromDisplayValue = (displayValue) => {
  if (!displayValue) {
    return '';
  }

  const parts = displayValue.toString().split('|');
  return parts.length > 1 ? parts[1] : '';
};

export const getApprovalTotalValue = (approvalObj, getColumnValueFn) => {
  const totalFromDisplay = getColumnValueFn(approvalObj, 'Total (incl. tax)');
  const displayAmount = parseAmountFromDisplayValue(totalFromDisplay);
  if (displayAmount !== null) {
    return displayAmount;
  }

  const requestBody = getRequestBodyFromApproval(approvalObj);
  if (_.has(requestBody, 'order-price.total-with-tax')) {
    return requestBody['order-price']['total-with-tax'];
  }

  if (_.has(approvalObj, 'approvalMetaData.analyticsLogOtherDetails.totalValue')) {
    return approvalObj.approvalMetaData.analyticsLogOtherDetails.totalValue;
  }

  return 0;
};

export const getApprovalTotalCurrency = (approvalObj, getColumnValueFn) => {
  const totalFromDisplay = getColumnValueFn(approvalObj, 'Total (incl. tax)');
  const displayCurrency = parseCurrencyFromDisplayValue(totalFromDisplay);
  if (displayCurrency) {
    return displayCurrency;
  }

  const requestBody = getRequestBodyFromApproval(approvalObj);
  if (_.has(requestBody, 'currency')) {
    return requestBody.currency;
  }

  if (_.has(approvalObj, 'approvalMetaData.analyticsLogOtherDetails.currencyCode')) {
    return approvalObj.approvalMetaData.analyticsLogOtherDetails.currencyCode;
  }

  return '';
};

export const getCustomerStateCode = (approvalObj) => {
  const approvalMetaData = approvalObj.approvalMetaData || {};
  const requestBody = getRequestBodyFromApproval(approvalObj);

  if (approvalMetaData.customerState) {
    return approvalMetaData.customerState;
  }

  if (approvalMetaData.stateCode) {
    return approvalMetaData.stateCode;
  }

  if (_.has(requestBody, 'billing-address.state-code')) {
    return requestBody['billing-address']['state-code'];
  }

  if (_.has(requestBody, 'billing-address.state')) {
    return requestBody['billing-address'].state;
  }

  if (_.has(requestBody, 'state')) {
    return requestBody.state;
  }

  return '';
};

export const shouldShowCaliforniaEtfMessage = (approvalObj, featureFlags, getColumnValueFn) => {
  const enabledFeatureFlags = featureFlags || [];

  if (enabledFeatureFlags.indexOf(appConstants.ENABLE_ETF_DISPLAY_MESSAGE) === -1) {
    return false;
  }

  const countryCode = _.get(approvalObj, 'approvalMetaData.countryCode', '');
  if (countryCode !== 'US') {
    return false;
  }

  if (getCustomerStateCode(approvalObj) !== appConstants.CALIFORNIA_STATE_CODE) {
    return false;
  }

  const orderType = _.get(approvalObj, 'approvalMetaData.subsType', '');
  if (orderType !== appConstants.ORDER_TYPE_INDIVIDUAL) {
    return false;
  }

  const commitmentType = getColumnValueFn(approvalObj, 'Commitment (Billing)');
  if (commitmentType !== appConstants.ABM_COMMITMENT_YEAR) {
    return false;
  }

  return true;
};

export const formatEtfFeeDisplayAmount = (etfFeeAmount, currencyCode) => {
  const formattedAmount =
    typeof etfFeeAmount === 'number' ? etfFeeAmount.toFixed(2) : String(etfFeeAmount);

  if (currencyCode === 'USD') {
    return `$${formattedAmount}`;
  }

  if (currencyCode) {
    return `${currencyCode} ${formattedAmount}`;
  }

  return `$${formattedAmount}`;
};
